import { connectCurrentRefinements } from 'react-instantsearch-dom'
import { t } from 'i18next'

const ClearRefinements = ({ items, refine }: { items: any; refine: any }) => (
  <button
    className="mobileResetBtn"
    onClick={() => refine(items)}
    disabled={!items.length}
  >
    {t('reset_filters')}
  </button>
)

const MobileClearRefinements = connectCurrentRefinements(ClearRefinements)

export default MobileClearRefinements
